var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExteriorSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.11 86.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00095b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    className: "cls-1",
    d: "M31.55,54.35a4.39,4.39,0,0,0,6.22.06l.06-.06L77.31,14.78V28.12a4.4,4.4,0,0,0,8.8,0V4.2A3.72,3.72,0,0,0,86,3.32V2.55l-.22-.44-.22-.34h0A4.33,4.33,0,0,0,84.13.44L83.8.22,83.36,0H57.78a4.4,4.4,0,1,0,0,8.8H71.12L31.52,48.15a4.41,4.41,0,0,0,0,6.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-1",
    d: "M15.41,86.2H63.13A15.44,15.44,0,0,0,78.57,70.76V41.88a4.4,4.4,0,1,0-8.8,0V70.76a6.6,6.6,0,0,1-6.6,6.6H15.44a6.59,6.59,0,0,1-6.6-6.6V23a6.6,6.6,0,0,1,6.6-6.6H44.31a4.4,4.4,0,0,0,0-8.8H15.43A15.43,15.43,0,0,0,0,23.07V70.8A15.43,15.43,0,0,0,15.43,86.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExteriorSelected);
export default __webpack_public_path__ + "static/media/exterior-selected.5ea137e46a365d6f9cd5a4e9037f8d7f.svg";
export { ForwardRef as ReactComponent };